import { AddressDetails } from '../types';

export const formatAddressDetails = (details: AddressDetails) => {
  const address = details.address ?? '';
  const address2 = details.address2 ?? '';
  const city = details.city ?? '';
  const country = details.country ?? '';
  const state = details.state ?? '';
  const zip = details.zip ?? '';

  const firstLine = `${address}${address && address2 ? ', ' : ''}${address2}`;
  let secondLine = `${zip}${zip && city ? ' ' : ''}${city}${
    (zip || city) && state ? ', ' : ''
  }${state}${(zip || city || state) && country ? ', ' : ''}${country}`;

  if (country === 'US') {
    secondLine = `${city}${city && state ? ', ' : ''}${state}${
      (city || state) && zip ? ' ' : ''
    }${zip}${(city || state || zip) && country ? ', ' : ''}${country}`;
  }

  return {
    firstLine,
    secondLine,
  };
};
